import React, { FC } from 'react';
import { H4 } from '~/components/Typography';
import ButtonStyled from '~/components/Button/ButtonStyled';
import { Plan } from '~/types/plan';
import useWindowSize from '~/hooks/useWindowSize';
import ComparePlanButtonSelectionStyled from '~/components/ComparePlansModal/ComparePlansButtonSelection/ComparePlanButtonCardDetailStyled';

interface Props {
  planDetail: Plan;
  onSelectProduct?: (productId: string) => void;
}

const ComparePlanButtonSelection: FC<Props> = ({ planDetail, onSelectProduct }) => {
  const { xsMobile, mobile } = useWindowSize();
  const isSmallScreen = xsMobile || mobile;
  return (
    <ComparePlanButtonSelectionStyled selected={!!planDetail}>
      {planDetail && (
        <>
          <div className="plan-name">
            <H4>{planDetail.name}</H4>
          </div>
          <div className="btn-select-plan-compare">
            <ButtonStyled
              onClick={() => {
                onSelectProduct && onSelectProduct(planDetail.productId);
              }}
            >
              {!isSmallScreen ? 'SELECT' : 'Select'}
            </ButtonStyled>
          </div>
        </>
      )}
    </ComparePlanButtonSelectionStyled>
  );
};

export default ComparePlanButtonSelection;
ComparePlanButtonSelection.displayName = 'ComparePlanButtonSelection';
